'use client';

import { usePathname } from 'next/navigation';
import type { Locale } from '@/i18n/config';
import { displayLocales, localeMeta } from '@/i18n/locale-meta';

const siteUrl = 'https://youth.winnerschapelcanada.ca';
const LOCALE_PREFIX_REGEX = /^\/(en|fr|es|creole)(?=\/|$)/;

type Props = {
  locale: Locale;
};

export function HreflangTags({ locale }: Props) {
  const pathname = usePathname();

  // Remove the current locale prefix to get the base path
  const basePath = pathname.replace(LOCALE_PREFIX_REGEX, '') || '';

  return (
    <>
      {displayLocales.map((loc) => (
        <link
          key={loc}
          rel="alternate"
          hrefLang={localeMeta[loc].hreflang}
          href={`${siteUrl}/${loc}${basePath}`}
        />
      ))}
      <link rel="alternate" hrefLang="x-default" href={`${siteUrl}/en${basePath}`} />
      <link rel="canonical" href={`${siteUrl}/${locale}${basePath}`} />
    </>
  );
}
